<template lang="pug">
div(
    :data-product-id="yotpoId"
    :data-name="yotpoName"
    :data-url="dataURL"
    data-mode="questions"
    class="yotpo yotpo-main-widget overflow-hidden"
)
</template>
<script>
import mixin from './mixin'

export default {
    mixins: [mixin],
    props: {
        yotpoId: {
            type: String,
            required: true,
        },
        yotpoName: {
            type: String,
            required: true,
        },
    },
    computed: {
        dataURL() {
            return 'https://' + this.$sitewideData.domain + '/p/' + this.$route.params.productLine
        },
    },
}
</script>
